/**
 * Registers the PWA service worker. Skipped in dev (CRA's dev server doesn't
 * play well with SW caching) and on platforms that don't support it.
 *
 * The SW handles:
 *  - app-shell caching for offline shell
 *  - web-push notification display
 *
 * Push subscription itself is set up separately (see hooks/usePushSubscription).
 */

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV === 'development') {
    // A SW installed in a previous prod session keeps controlling pages until
    // unregistered — and its cache-first fetch handler will serve stale (or
    // missing) JS chunks in dev, causing ChunkLoadError for newly-added pages.
    unregisterServiceWorker();
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        // Hook update detection. We don't auto-reload — that's hostile UX
        // for an agent mid-conversation. Show a banner instead (caller can
        // listen to `pingohub:sw-updated`).
        if (reg.waiting) {
          window.dispatchEvent(new CustomEvent('pingohub:sw-updated', { detail: { registration: reg } }));
        }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent('pingohub:sw-updated', { detail: { registration: reg } }));
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[SW] Registration failed:', err);
      });
  });
}

export function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    for (const r of regs) r.unregister().catch(() => {});
  });
}
